module.exports = __webpack_public_path__ + "MOBILEVERSION-197c2d9e.webp";